export default __webpack_public_path__ + "static/woolies-3cd3ca603a2429ef3a1967acbd71e75e.png";